module.exports = __webpack_public_path__ + "static/img/MGI.c2a5da8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/MGI.png
// module id = nx9m
// module chunks = 34